module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_3.5a397d81.png";